// extracted by mini-css-extract-plugin
module.exports = {"container":"Lolipop_container__2L-Pj","lolipop":"Lolipop_lolipop__3zU5E","lolipopStick":"Lolipop_lolipopStick__YPXb6"};